export default __webpack_public_path__ + "static/tetris-preview-2-43c601cbc6262bb9af588b1126e7b1a5.png";